import { UserPermission } from '@/modules/permission/enum';
export const taskRoutes = [
    {
        path: '',
        name: 'Tasks',
        exact: true,
        component: () => import('../views/TaskIndex.vue'),
        meta: {
            breadcrumb: [{ label: 'Tasks' }],
            permissions: [UserPermission.READ_TASK],
        },
    },
    {
        path: 'form',
        name: 'TaskForm',
        exact: true,
        component: () => import('../views/TaskForm.vue'),
        meta: {
            breadcrumb: [{ parent: { label: 'Tasks', routerLink: { name: 'Tasks' } }, label: 'Task Form' }],
            permissions: [UserPermission.WRITE_TASK],
        },
    },
    {
        path: 'draft',
        name: 'DraftTasks',
        exact: true,
        component: () => import('../views/DraftTaskTable.vue'),
        meta: {
            breadcrumb: [{ parent: { label: 'Tasks', routerLink: { name: 'Tasks' } }, label: 'Draft Tasks' }],
            permissions: [UserPermission.READ_TASK],
        },
    },
    {
        path: ':id',
        name: 'TaskDetails',
        props: true,
        exact: true,
        component: () => import('../views/TaskDetails.vue'),
        meta: {
            breadcrumb: [{ parent: { label: 'Tasks', routerLink: { name: 'Tasks' } }, label: 'Task Details' }],
            permissions: [UserPermission.READ_TASK],
        },
    },
];
